<template>
  <div class="user-collection">
    <el-dialog
      title=""
      :fullscreen="true"
      :show-close="false"
      :visible.sync="dialogFormVisible"
    >
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        v-if="dialogFormVisible"
      >
        <!--我收藏的单品-->
        <el-tab-pane
          :label="$t('addConfigModule.myCollection')"
          name="first"
          class="firstLabel"
        >
          <div>
            <div
              ref="headsection"
              class="head-section"
            >
              <div ref="headtap">
                <el-form ref="form" :model="form" :inline="true">
                  <!--搜索框-->
                  <el-row :gutter="24">
                    <el-col :span="4">
                      <el-form-item prop="productLine" class="mr-8">
                        <el-select
                          v-model="form.productLine"
                          filterable
                          clearable
                          :placeholder="$t('addConfigModule.clickProductLine')"
                          :loading="loading"
                          value-key="lineId"
                          @change="onProdLineChange"
                          @clear="clearLine"
                        >
                          <el-option
                            v-for="item in allProdLines"
                            :key="item.lineId"
                            :label="item.lineName"
                            :value="item"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item prop="productCategories" class="mr-8">
                        <el-select
                          v-model="form.productCategories"
                          filterable
                          clearable
                          reserve-keyword
                          :placeholder="$t('addConfigModule.clickProductCategories')"
                          :loading="loading"
                          value-key="categoryId"
                          @change="onProductCategoriesChange"
                          @clear="clearCategories"
                        >
                          <el-option
                            v-for="item in allProductCategories"
                            :key="item.categoryId"
                            :label="item.categoryName"
                            :value="item"
                          >
                            <span style="font-weight: bold">
                              {{ `[${$t('addConfigModule.productCategory')}]：` +item.categoryName }}
                            </span>
                            {{ `[${$t('addConfigModule.productLine')}]：` + item.lineName }}
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item prop="productSeries" class="mr-8">
                        <el-select
                          v-model="form.productSeries"
                          filterable
                          clearable
                          reserve-keyword
                          :placeholder="$t('addConfigModule.clickProductSeries')"
                          :loading="loading"
                          value-key="seriesId"
                          @change="seachForm"
                        >
                          <el-option
                            v-for="item in allProductSeries"
                            :key="item.seriesId"
                            :label="item.seriesName"
                            :value="item"
                          >
                            <span style="font-weight: bold">
                              {{ `[${$t('addConfigModule.productRange')}]：` +item.seriesName }}
                            </span>
                            {{ `[${$t('addConfigModule.productCategory')}]：`+item.categoryName }}
                            {{ `[${$t('addConfigModule.productLine')}]：` + item.lineName }}
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item prop="lineProperty" class="mr-8">
                        <el-cascader
                          v-model="form.lineProperty"
                          :options="allLinePropertyMap"
                          :show-all-levels="false"
                          clearable
                          :filterable="false"
                          expand-trigger="hover"
                          :placeholder="$t('addConfigModule.accordingProductClassification')"
                          :props="{value: `propertyCode`,label: `propertyName`,children: `children`}" @change="seachForm"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item prop="keys" class="mr-8">
                        <el-input
                          v-model="form.keys"
                          :placeholder="$t('addConfigModule.searchProductModel')"
                          @keyup.enter.native="seachForm"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="seachForm()"
                        >
                          {{ $t('addConfigModule.search') }}
                        </el-button>
                        <el-button
                          @click="resetForm('form')"
                        >
                          {{ $t('addConfigModule.reset') }}
                        </el-button>
                        <el-button
                          @click="goback"
                        >
                          {{ $t('addConfigModule.close') }}
                        </el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!--多选框-->
                  <el-row :gutter="24" type="flex" justify="space-between">
                    <el-col :span="17">
                      <el-form-item prop="productStatus" class="mr-8">
                        <el-checkbox
                          v-model="form.productStatus"
                          true-label="0"
                          false-label=""
                          @change="seachForm"
                        >
                          {{ $t('addConfigModule.hideDeliSting') }}
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item
                        prop="isSpecialControlled"
                        class="mr-8"
                      >
                        <el-checkbox
                          v-model="form.isSpecialControlled"
                          true-label="true"
                          false-label="false"
                          @change="seachForm"
                        >
                          {{ $t('addConfigModule.hiddenFor') }}
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item prop="isProductPackage" class="mr-8">
                        <el-checkbox
                          v-model="form.isProductPackage"
                          true-label="true"
                          false-label="false"
                          @change="seachForm"
                        >
                          {{ $t('addConfigModule.hideComboPackage') }}
                        </el-checkbox>
                      </el-form-item>
                      <el-form-item
                        prop="showOpticalModule"
                        class="mr-8"
                      >
                        <el-checkbox
                          v-model="form.showOpticalModule"
                          true-label="true"
                          false-label="false"
                          @change="seachForm"
                        >
                          {{ $t('addConfigModule.hideLightModule') }}
                        </el-checkbox>
                      </el-form-item>
                    </el-col>
                    <el-col :span="7" style="padding-right: 90px;text-align: right;">
                      <el-button
                        class="create-product-group"
                        type="primary"
                        @click="createProductGroupSubItem"
                      >
                        {{ $t('addConfigModule.addProductConfigureGroup') }}
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
            <el-table
              style="margin-top: 20px"
              :data="ProductInitListVO"
              border
              :header-cell-style="{'text-align': 'left',background:'#eef1f6'}"
              :stripe="false"
            >
              <el-table-column
                prop="seriesName"
                :label="$t('addConfigModule.productRange')"
                min-width="9%"
                align="left"
              />
              <el-table-column
                prop="productName"
                :label="$t('addConfigModule.productModel')"
                min-width="15%"
                align="left"
              >
                <template slot-scope="scope">
                  <ProductNameFormation :scope="scope" />
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('addConfigModule.productDes')"
                :render-header="foo"
                min-width="20%"
                align="left"
              >
                <template slot-scope="scope">
                  <long-text
                    :text="scope.row.productDesc"
                    :switch-flg="switchFlgP"
                  />
                </template>
              </el-table-column>

              <el-table-column
                prop="productPrice"
                :label="$t('addConfigModule.priceRMB')"
                width="120"
                align="right"
                :formatter="priceFormat"
              >
                <template slot-scope="scope">
                  {{ priceFormat(scope.row,scope.column,scope.row.productPrice) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="purchaseQuantity"
                :label="$t('addConfigModule.theNumber')"
                min-width="10%"
                align="left"
              >
                <template slot-scope="scope">
                  <el-input-number
                    size="mini"
                    controls-position="right"
                    v-model="scope.row.purchaseQuantity"
                    :min="0"
                    :precision="0"
                    :max="scope.row.optionalType === 1 &&
                      scope.row.subPropertyName === '主机' ? 1 : 99999"
                    @change="numberChange(scope.$index)"
                    style="width: 110px"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="productStatusStr"
                :label="$t('addConfigModule.status')"
                min-width="4%"
                align="left"
              >
                <template slot-scope="scope">
                  <ProductStatusFomation :scope="scope.row" />
                </template>
              </el-table-column>
              <el-table-column
                prop="productType"
                :label="$t('addConfigModule.periodAfterPreparationTime')"
                min-width="6%"
                align="left"
              >
                <template slot-scope="scope">
                  <ProductTypeFormation :scope="scope.row" />
                </template>
              </el-table-column>
              <el-table-column
                prop="productPscType"
                :label="$t('addConfigModule.serviceClassification')"
                min-width="3%"
                align="left"
              />
              <el-table-column
                :label="$t('addConfigModule.more')"
                min-width="4%"
                align="left"
              >
                <template slot-scope="scope">
                  <MoreContent :scope="scope" :is-partner="isPartner" />
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('addConfigModule.operation')"
                align="left"
                min-width="6%"
              >
                <template slot-scope="scope">
                  <!--<el-button @click="deleteUserCollection(scope.row)" type="text"><i class="el-icon-star-on"></i></el-button>-->
                  <span class="promotion" @click="deleteUserCollection(scope.row)"><i class="el-icon-star-on" /></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <!--我收藏的产品组合-->
        <el-tab-pane
          :label="$t('addConfigModule.myFavoritePortfolio')"
          name="second"
          class="table-added"
        >
          <div>
            <div style="height: 50px;">
              <el-form ref="packageform" :model="packageform" :inline="true">
                <el-row>
                  <el-col :span="24">
                    <el-form-item prop="packageLine" class="mr-8">
                      <el-select
                        v-model="packageform.packageLine"
                        filterable
                        clearable
                        :placeholder="$t('addConfigModule.clickProductLine')"
                        :loading="loading"
                        value-key="lineId"
                        @change="onPackageLineChange"
                        @clear="clearLine"
                      >
                        <el-option
                          v-for="item in allpackageLines"
                          :key="item.lineId"
                          :label="item.lineName"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>

                    <el-form-item prop="packageCategories" class="mr-8">
                      <el-select
                        v-model="packageform.packageCategories"
                        filterable
                        clearable
                        reserve-keyword
                        :placeholder="$t('addConfigModule.clickProductCategories')"
                        :loading="loading"
                        value-key="categoryId"
                        @change="onPackageCategoriesChange"
                        @clear="clearPackageCategories"
                      >
                        <el-option
                          v-for="item in allpackageCategories"
                          :key="item.categoryId"
                          :label="item.categoryName"
                          :value="item"
                        >
                          <span style="font-weight: bold">
                            {{ `[${$t('addConfigModule.productCategory')}]：` +item.categoryName }}
                          </span>
                          {{ `[${$t('addConfigModule.productLine')}]：` + item.lineName }}
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item prop="packageSeries" class="mr-8">
                      <el-select
                        v-model="packageform.packageSeries"
                        filterable
                        clearable
                        reserve-keyword
                        :placeholder="$t('addConfigModule.clickProductSeries')"
                        :loading="loading"
                        value-key="seriesId"
                        @change="seachPackageForm"
                      >
                        <el-option
                          v-for="item in allpackageSeries"
                          :key="item.seriesId"
                          :label="item.seriesName"
                          :value="item"
                        >
                          <span style="font-weight: bold">{{ '[产品系列]：' +item.seriesName }}</span>
                          {{ `[${$t('addConfigModule.productCategory')}]：`+item.categoryName }}
                          {{ `[${$t('addConfigModule.productLine')}]：` + item.lineName }}
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item prop="keys" class="mr-8">
                      <el-input
                        v-model="packageform.keys"
                        :placeholder="$t('addConfigModule.searchPortfolioName')"
                        @keyup.enter.native="seachPackageForm"
                      />
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        @click="seachPackageForm()"
                      >
                        {{ $t('addConfigModule.search') }}
                      </el-button>
                      <el-button
                        @click="resetPackageForm('packageform')"
                      >
                        {{ $t('addConfigModule.reset') }}
                      </el-button>
                      <el-button
                        @click="gobackAdded"
                      >
                        {{ $t('addConfigModule.close') }}
                      </el-button>
                    </el-form-item>
                    <el-form-item style="float: right">
                      <el-button
                        type="primary"
                        @click="addPackageToGroupSubItem"
                      >
                        {{ $t('addConfigModule.addProductConfigureGroup') }}
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <table
              style="width: 100%; margin-top: 20px"
              class="table-favorite"
              cellspacing="0"
              cellpadding="0"
            >
              <thead>
                <tr>
                  <th width="10%" class="td-left">
                    {{ $t('addConfigModule.assortmentName') }}
                  </th>
                  <th width="15%" class="td-left">
                    {{ $t('addConfigModule.productModel') }}
                  </th>
                  <th width="15%" class="td-left">
                    {{ $t('addConfigModule.productDes') }}
                    <button
                      @click="expandDiscribe"
                      class="expand-describe-tips"
                    >
                      {{ $t('addConfigModule.expandOrCloseAll') }}
                    </button>
                  </th>
                  <th width="8%" class="td-left">
                    {{ $t('addConfigModule.price') }}
                  </th>
                  <th width="10%" class="td-left">
                    {{ $t('addConfigModule.theNumber') }}
                  </th>
                  <th width="8%" class="td-left">
                    {{ $t('addConfigModule.status') }}
                  </th>
                  <th width="8%" class="td-left">
                    {{ $t('addConfigModule.periodAfterPreparationTime') }}
                  </th>
                  <th width="3%" class="td-left">
                    {{ $t('addConfigModule.serviceClassification') }}
                  </th>
                  <th width="5%" class="td-left">
                    {{ $t('addConfigModule.more') }}
                  </th>
                  <th width="5%" class="td-left">
                    {{ $t('addConfigModule.operation') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(packageItem) in packageInitListVO">
                  <tr :key="packageItem.packageId">
                    <td class="td-left td-color-hui">
                      <el-input
                        style="width: 100%"
                        v-model="packageItem.packageName"
                        :placeholder="$t('addConfigModule.assortmentName') "
                        @change="updatePackageName(packageItem)"
                      />
                    <!--{{packageItem.packageName}}-->
                    </td>
                    <td
                      colspan="8"
                      class="td-left td-color-hui"
                    >
                      <span style="width: 17%; padding-left: 10px">
                        {{ $t('addConfigModule.powerConsumption') }}：
                        <span class="f-blue">
                          {{ packageItem.powerDissipation }}
                        </span>
                      </span>&nbsp;
                      <span style="width: 17%; padding-left: 10px">
                        {{ $t('addConfigModule.priceRMB') }}：
                        <span style="color: #fd7f57">
                          {{ productPriceFormat(null,null,packageItem.productPrice) }}
                        </span>
                      </span>&nbsp;
                      <span style="width: 10%; padding-left: 10px">
                        {{ $t('addConfigModule.amount') }}：
                        <span class="f-blue">
                          {{ packageItem.quantity }}
                        </span>
                      </span>&nbsp;
                      <span style="width: 10%; padding-left: 10px">
                        {{ $t('addConfigModule.numberOf') }}：
                        <el-input-number
                          v-model="packageItem.purchaseQuantity"
                          controls-position="right"
                          :precision="0"
                          :min="0"
                          :label="$t('addConfigModule.discountFont')"
                          size="mini"
                        />
                      </span>
                    </td>
                    <td class="td-left td-color-hui">
                      <el-button
                        type="text"
                        @click="deletePackage(packageItem)"
                      >
                        {{ $t('addConfigModule.delete') }}
                      </el-button>
                    </td>
                  </tr>
                  <tr
                    v-for="(item,index) in packageItem.productInitListVO"
                    :key="item.packageId+index"
                  >
                    <td />
                    <td class="td-left">
                      {{ item.productName }}
                      <span
                        v-if="item.optionalType==1
                          && item.propertyCode === '1001'"
                      >
                        <span class="promotion">
                          <img src="@/assets/selectProduct.png" alt="err">
                        </span>
                      </span>
                      <span v-if="item.standardFlag==1">
                        <span class="promotion">
                          <img src="@/assets/newImport.png" alt="err">
                        </span>
                      </span>
                      <span v-if="item.isDiscount && !isPartner">
                        <span class="promotion">
                          <img src="@/assets/promotion-new.png" alt="err">
                        </span>
                      </span>
                      <span v-if="isControlled(item)">
                        <span class="promotion">
                          <img src="@/assets/controlled-new.png" alt="err">
                        </span>
                      </span>
                      <span v-if="isNewProduct(item)">
                        <span class="promotion">
                          <img src="@/assets/newproduct-new.png" alt="err">
                        </span>
                      </span>
                      <span
                        v-if="item.industryIsEnabled==false"
                        class="promotion"
                      >
                        <img src="@/assets/shelves-new.png" alt="err">
                      </span>
                      <span
                        v-if="item.quotation==1"
                        class="promotion2"
                      >
                        <img src="@/assets/fuwushang-new.png" alt="err">
                      </span>
                      <span
                        v-if="item.quotation==2 && getStore('industryFlg') == 1"
                        class="promotion2"
                      >
                        <img src="@/assets/fuwushang-new.png" alt="err">
                      </span>
                    </td>
                    <td class="td-left">
                      <long-text
                        :text="item.productDesc"
                        :switch-flg="switchFlgP"
                      />
                    </td>
                    <td class="td-right">
                      {{ productPriceFormat(null,null,item.productPrice) }}
                    </td>
                    <td class="td-left">
                      <el-input-number
                        v-model="item.quantity"
                        controls-position="right"
                        :precision="0"
                        :min="0"
                        :label="$t('addConfigModule.discountFont')"
                        size="mini"
                        @change="updatePackage(item)"
                      />
                    </td>
                    <td class="td-left">
                      <ProductStatusFomation :scope="item" />
                    </td>
                    <td class="td-left">
                      <ProductTypeFormation :scope="item" />
                    </td>
                    <td class="td-left">{{ item.productPscType }}</td>
                    <td class="td-left">
                      <span v-show="showRemark(item)">
                        <el-popover trigger="click" placement="top">
                          <div v-if="showDiscount(item)">
                            <p>
                              <span>
                                {{ $t('addConfigModule.promotionPrice') }}：
                                {{ item.promotionPrice }}
                                {{ $t('addConfigModule.yuan') }}
                              </span>
                            </p>
                            <p>
                              <span
                                v-if="item.discountEndDateTime == null && item.discountStartDateTime == null"
                              >
                                {{ $t('addConfigModule.promotionTime') }}
                                ：{{ $t('addConfigModule.wu') }}
                              </span>
                              <span
                                v-else
                              >
                                {{ $t('addConfigModule.promotionTime') }}
                                ：{{ item.discountStartDateTime }}
                                {{ $t('addConfigModule.zhi') }}
                                {{ item.discountEndDateTime }}
                              </span>
                            </p>
                          </div>
                          <div
                            v-if="(item.isSpdc === 1 &&
                              getStore('partnerFlg') === 'Partner' &&
                              getStore('partnerAuth') === '1' ||
                              getStore('partnerFlg') !== 'Partner')"
                          >
                            <p>
                              <span>
                                {{ $t('addConfigModule.serviceProviderPrice') }}
                                ：{{ item.spdcPrice }}
                                {{ $t('addConfigModule.yuan') }}
                              </span>
                            </p>
                            <p
                              v-if="item.isSpdcDiscount != null && item.isSpdcDiscount == 1"
                            >
                              <span
                                v-if="item.spdcDiscountStartTime == null && item.spdcDiscountEndTime == null"
                              >
                                {{ $t('addConfigModule.promotionTime') }}：
                                {{ $t('addConfigModule.wu') }}
                              </span>
                              <span
                                v-else
                              >
                                {{ $t('addConfigModule.promotionTime') }}：
                                {{ item.spdcDiscountStartTime }}
                                {{ $t('addConfigModule.zhi') }}
                                {{ item.spdcDiscountEndTime }}
                              </span>
                            </p>
                          </div>
                          <p v-html="item.remarks " />
                          <div slot="reference" class="name-wrapper">
                            <el-tag size="medium">
                              <i>
                                <img src="../../assets/remark.png" alt="err">
                              </i>
                            </el-tag>
                          </div>
                        </el-popover>
                      </span>
                    </td>
                    <td class="td-left">
                      <el-button
                        type="text"
                        @click="deletePackage(item)"
                      >
                        {{ $t('addConfigModule.delete') }}
                      </el-button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div>
        <el-dialog
          :title="$t('addConfigModule.productTips')"
          :visible.sync="dialogNoticeVisible"
          append-to-body
        >
          <div
            style="color: red"
            v-if="noticeText !=null && noticeText !=''"
          >
            {{ $t('addConfigModule.productsAddedChangedPleaseReCollect') }}：{{ noticeText }}
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelWind">
              {{ $t('addConfigModule.cancel') }}
            </el-button>
          </div>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CommonAddition } from '@/utils/addproductMinxin';
import { PackagePage } from '@/utils/packageMinxin';
import { setStore, getStore, notesTextFormat } from '@/utils/mUtils';
import api from '@/api';
import ProductStatusFomation from '../components/ProductStatusFomation';
import ProductTypeFormation from '../components/ProductTypeFormation';
export default {
  name: 'UserCollection',
  components: { ProductTypeFormation, ProductStatusFomation },
  mixins: [CommonAddition, PackagePage],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    configurationGroup: {
      type: Object
    }
  },
  data () {
    return {
      activeName: 'first'
    };
  },
  methods: {
    getStore,
    notesTextFormat,
    deleteUserCollection (row) {
      this.$confirm(this.$t('addConfigModule.cancelFavoriteProduct'), this.$t('addConfigModule.prompt'), {
        confirmButtonText: this.$t('addConfigModule.determine'),
        cancelButtonText: this.$t('addConfigModule.cancel'),
        type: 'warning'
      }).then(() => {
        let param = {
          params: {
            productCode: row.productCode,
            seriesId: row.seriesId
          }
        };
        api.deleteUserCollection(param).then((response) => {
          let jsonData = response.data;
          if (jsonData.status === '200') {
            this.$notify({
              type: 'success',
              message: this.$t('addConfigModule.cancelCollectionSuccessfully')
            });
            this.seachForm();
          }
        }).catch(err => {
          this.$notify.error(this.$t('addConfigModule.failedCancelCollectionContactAdmin'), err);
        });
      });
    }

  }
};

</script>
<style lang="scss" scoped>
.user-collection {
  .el-input--small {
    width: 300px;
  }
  .el-select{
    width: 250px;
  }
   .el-cascader{
    width: 300px;
  }
  ::v-deep .el-table td.el-table__cell div{
    word-break: break-word;
  }
}
</style>
<style lang="scss">
  @import "../../styles/product-common.css";
  @import "../../styles/product-table.css";
.user-collection {
  .td-left{
    text-align: left;
    padding-left: 10px !important;
  }
  .el-tabs--card>.el-tabs__header .el-tabs__nav{
   border: none;
  }
  .table-favorite th{
    background-color: #eef1f6 !important;
    height: 2.6rem !important;
  }
}
  .user-collection .create-product-group{
    height: 32px;
    border:  1px solid #3fbbdc !important;
    color: #3fbbdc;
    background-color:#FFFFFF !important;
  }
  .user-collection .expand-describe-tips{
    float: right;
    color:#3fbbdc;
    border:none;
    border-radius:5px;
    height:20px;
    margin-right: 20px;
    padding: 0 5px;
  }
  .user-collection .el-table .cell{
    white-space: normal;
  }
  .user-collection .el-tabs__item.is-active{
    border: 1px solid #cccccc !important;
  }
  .clearfloat{
    clear: both;
  }
  .user-collection {
    .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
      height: 30px;
      line-height: 30px;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__item:first-child{
      height: 30px;
      line-height: 30px;
    }
    .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child  {
      height: 30px;
      line-height: 30px;
    }
  }
  .user-collection .el-row{
    margin-bottom: 20px;
  }
  .user-collection .table{
    margin-bottom: 0;
  }
  .user-collection .head-section{
    height:  80px;
  }
  .clear{
    clear:both;
  }

  .user-collection .el-form-item{
    float: left;
    margin-right: 0;
    margin-bottom: 0;
  }

  .user-collection .table .el-table .cell{
    white-space:normal;
  }

  .user-collection .el-dialog__body{
    padding: 10px 10px;
  }

  .user-collection .dialog-footer{
    text-align: center;
  }

  .el-popover{
    width: 300px;
  }

  .user-collection   .promotion{
    font-size: 20px;
    color:#37BADE;
  }
  .el-col {
    border-radius: 4px;
  }

  .user-collection .el-dialog__header{
    height: 3px;
    padding: 0px;
  }

  .el-tabs__item{
    background: #37BADE;
    border: 1px solid #37BADE;
    color: white;
    height: 2rem;
    line-height: 2rem;
    &.is-active{
      background: white;
      border: 1px solid #37BADE;
      color: black;
      height: 2rem;
      line-height: 2rem;
    }
  }
  @media screen and (max-width: 1366px) {
    .user-collection table *{
      margin: 0;
      padding: 0;
    }
    .user-collection .table{
      margin-bottom: 0;
    }

  }

</style>

<style scoped>
.mr-8{
  margin-right: 18px !important;
}
.user-collection .head-section{
  height: 80px;
}
</style>
